<!--  -->
<template>
  <div class="product-detail tal">
    <img class="common-banner" src="/img/page_banner.png" />
    <div class="container">
      <div class="header mt10 mb30">
        <el-button class="back mr10" type="text" icon="el-icon-arrow-left" @click="$router.go(-1)">返回</el-button>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ name: 'selectCenter', query: {tab: 'activity'} }">选品中心</el-breadcrumb-item>
          <el-breadcrumb-item>品牌</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="df pb33">
        <div class="flex-0 mr13">
          <img class="brand-logo" :src="activityInfo.brandLogoUrl" />
        </div>
        <div class="brand-info flex-1">
          <p>
            <span class="brand-name">{{activityInfo.brandName}}</span>
            <span class="ml12">{{formatRemainTime(activityInfo)}}</span>
          </p>
          <p class="mt7">发货：{{activityInfo.shipInfo}}</p>
          <p class="mt7">服务：{{serviceText}}</p>
          <p class="mt7 df-aic">优惠：
            <span class="promo-container">
              <span v-if="activityInfo.hasCoupon" class="promo-tag coupon"></span>
              <span v-if="activityInfo.hasProfitAdditional" class="promo-tag profit"></span>
              <span v-if="activityInfo.hasSuperHot" class="promo-tag hot"></span>
              <span v-if="activityInfo.hasSecKill" class="promo-tag seckill"></span>
            </span>
          </p>
          <p v-if="activityInfo.couponList && activityInfo.couponList.length > 0" class="mt9">
            <span>优惠券：</span>
            <span v-for="(item, key) in activityInfo.couponList" class="product-info-tags" :key="key">{{item}}</span>
          </p>
          <p class="mt9">{{activityInfo.activityDesc}}</p>
        </div>
      </div>
      <el-row class="mb30">
        <el-radio-group v-model="sortedModel">
          <el-radio-button :label="1" @click.native="changeType(1)">综合(默认）</el-radio-button>
          <el-radio-button
            :label="7"
            @click.native="changeType(7)">
            按建议零售价排序
            <i :class="sortedModel !== 7 ? 'el-icon-d-caret' : (sortedType === 1 ? 'el-icon-caret-top' : 'el-icon-caret-bottom')" />
          </el-radio-button>
          <el-radio-button
            :label="6"
            @click.native="changeType(6)">
            按上新排序
            <i :class="sortedModel !== 6 ? 'el-icon-d-caret' : (sortedType === 1 ? 'el-icon-caret-top' : 'el-icon-caret-bottom')" />
          </el-radio-button>
        </el-radio-group>
      </el-row>
      <el-row v-loading="isLoading">
        <el-row>
          <div class="brand-list">
            <!-- :key="item.productId" -->
            <ProductCard
              v-for="item in productList"
              class="brand-item"
              :card-info="item"
              :key="item.productId"
            />
          </div>
        </el-row>
        <el-row v-if="productTotal === 0" class="tac pb40" justify="center">暂无商品</el-row>
        <el-row v-else>
          <el-pagination
            class="mt30 tar pb40"
            @current-change="(size) => { onCurrentChange(size, 'product') }"
            :current-page="productPageNum"
            :page-size="productPageSize"
            layout="total, prev, pager, next, jumper"
            :total="productTotal">
          </el-pagination>
        </el-row>
      </el-row>
    </div>
  </div>
</template>

<script>
import ProductCard from '@/components/common/productCard.vue';
import { formatRemainTime } from '@/utils';
export default {
  name: 'brandDetail',
  components: { ProductCard },
  data () {
    return {
      sortedModel: 1,
      sortedType: 2,
      activityId: this.$route.params.id,
      activityInfo: {},
      productForm: {},
      productLoading: false,
      productPageSize: 10,
      productPageNum: 1,
      productTotal: 0,
      productList: [],
      isLoading: false,
      timeout: false
    };
  },
  computed: {
    serviceText () {
      const service = [];
      const {
        refundInsurance,
        isExchangeRefundGoods
      } = this.activityInfo;
      if (refundInsurance) {
        service.push('退换运费无忧');
      }
      let refundText = '七天无理由退货';
      switch (isExchangeRefundGoods) {
        case 0:
          refundText = '不支持' + refundText;
          break;
        case 1:
          refundText = '支持' + refundText;
          break;
        case 2:
          refundText = '拆封后不支持' + refundText;
          break;
        case 3:
          refundText = '激活后不支持' + refundText;
          break;
        default:
          refundText = '';
      }
      if (typeof isExchangeRefundGoods === 'number') {
        service.push(refundText);
      }
      return service.join('、');
    }
  },
  watch: {
    '$route.params.id': function (val) {
      if (!val) {
        return;
      }
      console.log(val);
      console.log(this.activityId);
      console.log(this.productPageNum);
      if (val !== this.activityId) {
        this.productPageNum = 1;
        this.sortedModel = 1;
        this.sortedType = 2;
        this.activityInfo = {};
        this.productList = [];
      }
      this.activityId = val;
      this.getActivityDetail();
      this.refresh();
    }
  },
  created () {
    this.getActivityDetail();
    this.refresh();
  },
  methods: {
    refresh () {
      this.getProductActivityList();
    },
    getActivityDetail () {
      this.$http.activityDetailV3({
        activityNo: this.activityId
      }).then(({ data }) => {
        this.activityInfo = data;
      });
    },
    getProductActivityList () {
      this.isLoading = true;
      this.$http.getProductActivityListV3({
        activityNo: this.activityId,
        sortedModel: this.sortedModel,
        sortedType: this.sortedType,
        pageIndex: this.productPageNum,
        pageSize: this.productPageSize
      }).then(({ data }) => {
        this.isLoading = false;
        this.productList = data.result;
        this.productTotal = Number(data.total);
      }).catch(() => {
        this.isLoading = false;
      });
    },
    changeType (sortedModel) {
      if (this.timeout) {
        return '';
      }
      this.timeout = true;
      setTimeout(() => {
        this.timeout = false;
      });
      if (sortedModel !== this.sortedModel) {
        this.sortedType = 2;
      } else {
        this.sortedType = (this.sortedType === 2 ? 1 : 2);
      }
      setTimeout(() => {
        this.refresh();
      });
    },
    onSizeChange (size, name) {
      this[name + 'PageSize'] = size;
      this[name + 'PageNum'] = 1;
      this.refresh();
    },
    onCurrentChange (current, name) {
      this[name + 'PageNum'] = current;
      this.refresh();
    },
    formatRemainTime (activityInfo) {
      const { activityStatus, beginTime, endTime } = activityInfo;
      switch (activityStatus) {
        case 1:
          return formatRemainTime(beginTime, '距开始d天H时m分');
        case 2:
          return formatRemainTime(endTime, '距结束d天H时m分');
        default:
          return '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
}
.brand {
  &-logo {
    display: block;
    width: 60px;
    height: 60px;
  }
  &-info {
    font-size: 14px;
    color: #333333;
    line-height: 20px;
  }
  &-name {
    font-size: 16px;
    font-weight: 500;
  }
  &-list {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    justify-items: center;
    margin-left: auto;
    margin-right: auto;
  }
  &-item {
    margin-bottom: 15px;
  }
}
.promo{
  &-container {
    display: inline-flex;
  }
  &-tag {
    margin-right: 4px;
    height: 18px;
    background-size: 100% 100%;
    &.coupon{
      width: 39px;
      background-image: url('./home/image/icon-coupon.png');
    }
    &.profit{
      width: 30px;
      background-image: url('./home/image/icon-profit.png');
    }
    &.hot{
      width: 40px;
      background-image: url('./home/image/icon-hot.png');
    }
    &.seckill{
      width: 28px;
      background-image: url('./home/image/icon-seckill.png');
    }
  }
}
.product-info-tags {
  display: inline-block;
  padding: 0 5px;
  margin-right: 5px;
  font-size: 12px;
  color: #F0426A;
  border: 1px solid #F0426A;
  line-height: 18px;
  box-sizing: border-box;
}
</style>
